import Equipamento from "./Equipamento";

export default class Servico {
  constructor(id, descricao, data, faturado, concluido) {
    this.id = id;
    this.descricao = descricao;
    this.data = data;
    this.faturado = faturado;
    this.concluido = concluido;
    this.equipamento = new Equipamento(0, "", "", "", "", "", "", "", "", "", "", "");
  }

  update(servico) {
    this.id = servico.id;
    this.descricao = servico.descricao;
    this.data = servico.data;
    this.faturado = servico.faturado;
    this.concluido = servico.concluido;
  }
}
